import { useDisclosure } from "@/hooks";
import { useNotificationStore } from "@/states/zustand/notification";
import { Button, Modal } from "antd";
import { useEffect } from "react";

export function DeleteConfirmationModal({
	onDelete,
	isDeleting = false,
	title,
	description = "Are you sure you want to delete this item?",
	buttonProps = {},
}: {
	onDelete: () => void;
	isDeleting?: boolean;
	title?: string;
	description?: string;
	buttonProps?: React.ComponentProps<typeof Button>;
}) {
	const [opened, { toggle, close: closeModal }] = useDisclosure(false);

	const noti = useNotificationStore((state) => state.notification);

	// Close modal when notification is set & type is success
	useEffect(() => {
		if (noti && noti.type === "success") {
			closeModal();
		}
	}, [noti, closeModal]);

	return (
		<>
			<Button
				type="text"
				size="small"
				{...buttonProps}
				danger
				onClick={toggle}
			>
				Delete
			</Button>
			<Modal
				title={title ? title : "Delete Confirmation"}
				open={opened}
				classNames={{
					header: "[&>.ant-modal-title]:!text-lg [&>.ant-modal-title]:!font-semibold [&>.ant-modal-title]:!font-poppins [&>.ant-modal-title]:!text-danger ",
				}}
				onCancel={toggle}
				onOk={onDelete}
				okButtonProps={{
					type: "primary",
					danger: true,
					size: "large",
					loading: isDeleting,
					className: "!font-poppins !text-sm",
				}}
				cancelButtonProps={{
					type: "text",
					size: "large",
					style: {
						background: "transparent",
					},
					disabled: isDeleting,
					className: "!font-poppins !text-sm",
				}}
				width={440}
				centered
				maskClosable={!isDeleting}
			>
				<article className="font-poppins text-neutral-500 py-2">
					<p>{description} This action can&apos;t be undone.</p>
				</article>
			</Modal>
		</>
	);
}
